import {ApiService} from "./api.service";
import {AxiosResponse} from "axios";
import {JobHistoryWithLogs} from "../model/interface/job-history.interface";

export class MigrationService {
    public static async triggerMigration(projectId: number) {
        let url: string = ApiService.getInstance().getTriggerMigrationURL(projectId);

        const result: AxiosResponse<string> | false = await ApiService.getInstance().getUnhandled(url);

        if(!result) {
            console.error("Could not trigger calculation");
            return null;
        }
        return result.data;
    }
    public static async getProjectWithJobLogs(logId: number) {
        let url: string = ApiService.getInstance().getProjectWithJobLogsURL(logId);

        const result: AxiosResponse<JobHistoryWithLogs> | false = await ApiService.getInstance().getUnhandled(url);

        if(!result) {
            console.error("Could not trigger calculation");
            return null;
        }
        return result.data;
    }

}